<div class="my-reports-container">
  <section class="guest" *ngIf="isGuest; else signedIn">
    <header class="guest-head">
      <ng-container *ngIf="guestOrder?.kind === 'confirming'; else settledHead">
        <span class="guest-badge guest-badge--pending" aria-hidden="true">
          <span class="guest-spinner"></span>
        </span>
        <div>
          <h2 class="guest-title">Confirming your payment</h2>
          <p class="guest-text">Checking with Stripe, a few seconds at most.</p>
        </div>
      </ng-container>
      <ng-template #settledHead>
        <ng-container *ngIf="guestHasPaid; else visitHead">
          <span class="guest-badge guest-badge--done" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
              <path
                d="M5 12.5l4.5 4.5L19 7.5"
                stroke="currentColor"
                stroke-width="2.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <div>
            <h2 class="guest-title">Payment received - thank you!</h2>
            <p class="guest-text">
              Your report appears here as soon as it is built, usually within a
              few minutes, and is also emailed to the address you entered at
              checkout.
            </p>
          </div>
        </ng-container>
      </ng-template>
      <ng-template #visitHead>
        <span class="guest-badge" aria-hidden="true">
          <app-icon svgIcon="report"></app-icon>
        </span>
        <div>
          <h2 class="guest-title">Your reports live here</h2>
          <p class="guest-text">
            Sign in to see your reports. Bought one without an account? Sign in
            with the email you paid with.
          </p>
        </div>
      </ng-template>
    </header>

    <ul class="guest-order" *ngIf="guestOrderReports.length > 0">
      <li *ngFor="let report of guestOrderReports" class="guest-tile">
        <span class="guest-tile-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
            <path
              d="M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linejoin="round"
            />
            <path
              d="M14 3v4h4M9.5 12.5h5M9.5 16h5"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <span class="guest-tile-text">
          <span class="guest-tile-name">{{ report.name }}</span>
          <span class="guest-tile-type">{{ reportTitle(report.type) }}</span>
        </span>
        <span class="guest-tile-actions">
          <a
            *ngIf="report.url; else reportStatus"
            class="guest-download"
            [href]="report.url"
            target="_blank"
            rel="noopener"
          >
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M12 4v11m0 0l-4.5-4.5M12 15l4.5-4.5M5 20h14"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Download
          </a>
          <ng-template #reportStatus>
            <span class="status-chip" [ngClass]="statusTone(report.status)">{{
              $any(report.status) | statusToText
            }}</span>
          </ng-template>
          <a
            *ngIf="makeAnotherUrl(report.type) as url"
            class="make-another"
            [href]="url"
            (click)="makeAnother(report.type, $event)"
            >Make another</a
          >
        </span>
      </li>
    </ul>

    <div class="guest-signin" [class.guest-signin--band]="guestHasPaid">
      <p class="guest-text" *ngIf="guestHasPaid">
        Want every report in one place? Sign in with that same email and they
        will all be here.
      </p>
      <button type="button" class="guest-signin-button" (click)="signIn()">
        Sign in
      </button>
    </div>
  </section>

  <ng-template #signedIn>
    <span class="time-disclaimer" *ngIf="isSomeReportInProgress"
      >Your report shall be ready in 3 minutes</span
    >

    <div *ngIf="requestedReports.length > 0; else noReports">
      <mat-table #table [dataSource]="requestedReports" class="table-desktop">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            (click)="handleLinkClick(element)"
          >
            <span
              [ngClass]="element.url ? 'text-underline link-like-text' : ''"
              >{{ element.name }}</span
            >
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{ reportTitle(element.type) }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            [matTooltip]="element.orderedAt | utcToLocal: 'MM/dd/yyyy, h:mm'"
            matTooltipPosition="above"
            matTooltipClass="tooltip"
          >
            {{ element.orderedAt | utcToLocal: 'MM/dd/yyyy' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            [ngClass]="statusTone(element.status)"
            [matTooltip]="element.status | reportStatusToTooltip"
          >
            {{ element.status | statusToText }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="another">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a
              *ngIf="makeAnotherUrl(element.type) as url"
              class="make-another"
              [href]="url"
              (click)="makeAnother(element.type, $event)"
              >Make another</a
            >
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns"></mat-row>
      </mat-table>

      <div
        *ngFor="let report of requestedReports; let i = index"
        class="report-status-mobile"
      >
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="text-content-title">
              <span
                (click)="handleLinkClick(report)"
                [ngClass]="report.url ? 'text-underline link-like-text' : ''"
                >{{ report.name }}</span
              >
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="text-content">
            <span>{{ report.orderedAt | date: 'MM/dd/yyyy' }}</span>
            <span [ngClass]="statusTone(report.status)">{{
              $any(report).status | statusToText
            }}</span>
            <a
              *ngIf="makeAnotherUrl(report.type) as url"
              class="make-another"
              [href]="url"
              (click)="makeAnother(report.type, $event)"
              >Make another</a
            >
          </div>
        </mat-expansion-panel>
        <mat-divider *ngIf="i < requestedReports.length - 1"></mat-divider>
      </div>
    </div>

    <ng-template #noReports>
      <div class="no-reports">
        <span class="no-reports-disclaimer">
          All your reports are kept here so you can access them anytime. Now you
          have no reports!</span
        >
        <a routerLink="/reports/order" class="link-like-text">
          <app-icon
            svgIcon="report"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: false }"
          ></app-icon>
          <span class="text-underline link-like-text"
            >Let’s order the first report</span
          >
        </a>
      </div>
    </ng-template>
  </ng-template>
</div>
